import { render, staticRenderFns } from "./BookOpenPageVariantOutline.vue?vue&type=template&id=33639e2d&"
import script from "./BookOpenPageVariantOutline.vue?vue&type=script&lang=js&"
export * from "./BookOpenPageVariantOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports